export default __webpack_public_path__ + "static/media/Kelvin_weapon.3e24285f.png";